
import { Vue, Options } from 'vue-class-component'
import { getUrlModalOptionsMyCoupon, modalOptionsCouponLotus } from '@/model/modal-options.model'
import { useStore } from '@/store'
import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper-bundle.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { DateFormat, getDate } from '@/helpers/date'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import { MyCoupon, MyCouponType } from '@/model/my-coupon.model'
import { mappingImageDefault } from '@/helpers/mapper'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { CouponsList } from '@/interfaces/my-coupon'

library.add(faChevronRight)

@Options({
  components: {
    Swiper,
    SwiperSlide,
    FontAwesomeIcon,
    QSkeleton
  },
  computed: {
    isLoading() {
      return this.$store.state.myCouponInfo.coupons.isLoading
    },
    couponsList() {
      return this.$store.state.myCouponInfo.coupons.items
    }
  }
})
export default class FreeCoupon extends Vue {
  store = useStore()
  modules = [FreeMode]
  textTitleName = MyCoupon.SPECIAL_FOR_YOU_TITLE
  textViewAll = MyCoupon.VIEW_ALL
  textCouponTypeGold = `Gold${MyCouponType.SPECIAL_FOR_YOU}`

  getImage(image: string) {
    return mappingImageDefault(image)
  }

  getExpiryDate(date: string) {
    return date ? getDate(date, DateFormat) : ''
  }

  errorImage(event: any) {
    event.target.onerror = null
    event.target.src = require('../../assets/img/coupon-image-placeholder.png')
    event.target.className = 'free-coupon-detail-img-default'
  }

  openModalCoupon(coupon: CouponsList) {
    const myCouponToken = this.store.state.lineInfo.idToken
    const couponType = MyCoupon.SPECIAL_FOR_U
    const customerType = this.store.state.customer?.customerType ?? undefined
    const url = getUrlModalOptionsMyCoupon(coupon?.couponId, 'lotus', 'coupon', couponType, customerType, undefined)
    modalOptionsCouponLotus.url = `${url}${coupon?.couponId ? '&action=back-to-line-web' : ''}&token=${myCouponToken}`

    this.store.commit('modalIframe/updateModalIframeActive', true)
    this.store.commit('modalIframe/updateModalOptionsIframe', modalOptionsCouponLotus)

    this.updateGAEvent(coupon)
  }

  updateGAEvent(coupon: CouponsList) {
    const customerType = this.store.state.customer?.customerType
    let objEvent = {}
    if (coupon?.couponId) {
      objEvent = {
        event: 'mylotuss_coupon_card',
        topic_section: 'coupons_spacial_for_you',
        component: 'free-coupon-slide',
        coupon_section: coupon?.couponName,
        coupon_type: coupon?.couponType,
        coupon_scope: customerType
      }
    } else {
      objEvent = {
        event: 'mylotuss_see_all',
        topic_section: 'coupons_spacial_for_you',
        component: 'free-coupon-title-view-all'
      }
    }
    addGAEvent(objEvent)
  }
}
